/**
 * Logo Format enum
 * @property {string} SQUARE - square
 * @property {string} RECTANGLE - rectangle
 * @property {string} WHITE_SQUARE - white_square
 * @property {string} WHITE_RECTANGLE - white_rectangle
 */
export var LogoFormat;
(function (LogoFormat) {
    LogoFormat["SQUARE"] = "square";
    LogoFormat["RECTANGLE"] = "rectangle";
    LogoFormat["WHITE_SQUARE"] = "white_square";
    LogoFormat["WHITE_RECTANGLE"] = "white_rectangle";
})(LogoFormat || (LogoFormat = {}));
